import React, {useEffect, useState} from 'react';
import OrderUtil from "../../../../../../utils/orders/OrderUtil";
import DateTimeUtil from "../../../../../../utils/common/DateTimeUtil";
import OrganizationCustomerService from "../../../../../../API/orders/orders/organization/OrganizationCustomerService";
import HeaderService from "../../../../../../API/orders/orders/organization/HeaderService";
import AttributesService from "../../../../../../API/orders/orders/organization/AttributesService";
import AttributeUtil from "../../../../../../utils/orders/AttributeUtil";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack} from "@mui/material";
import CreateOrderTextFieldObject from "./CreateOrderTextFieldObject";
import TextFieldWithSetValue from "../../../../textfield/TextFieldWithSetValue";
import OrderDatePicker from "../../../../datepicker/OrderDatePicker";
import MaterialTextFieldObjectWithEntityList from "../../../../modul/mainoptions/MaterialTextFieldObjectWithEntityList";
import {orderStatusForCreate} from "../../../../../../data/OrderStatus";
import CreateOrderTextFieldCustomer from "./CreateOrderTextFieldCustomer";
import ButtonExit from "../../../../button/ButtonExit";
import ButtonAdd from "../../../../button/ButtonAdd";
import {organizationOrderType} from "../../../../../../data/OrderType";

const CreateNewOrderModal = ({
                                 open,
                                 columns,
                                 onClose,
                                 onSubmit,
                                 defaultAttributeId,
                                 setDefaultAttributeId,
                                 handleModalAlert,
                                 loading
                             }) => {
    const [values, setValues] = useState(() =>
        columns.reduce((acc, column) => {
            if (OrderUtil.checkField(column)) {
                acc[column.id ?? ''] = '';
            }
            return acc;
        }, {status: Object.keys(orderStatusForCreate)[0], orderType: "STANDARD"}),
    );

    const [customerList, setCustomerList] = useState([]);
    const [modelHeaderList, setModelHeaderList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);

    const [customerId, setCustomerId] = useState(null);
    const [customerName, setCustomerName] = useState(null);

    const [modelHeaderId, setModelHeaderId] = useState(null);
    const [attributeId, setAttributeId] = useState(null);

    const [defaultCustomerId, setDefaultCustomerId] = useState(null);
    const [defaultCustomerName, setDefaultCustomerName] = useState(null);

    const [defaultModelHeaderId, setDefaultModelHeaderId] = useState(null);

    const [dateOfReceipt, setDateOfReceipt] = useState(new Date());
    const [dateOfPlannedProduction, setDateOfPlannedProduction] = useState(new Date());
    const [plannedDateOfShipment, setPlannedDateOfShipment] = useState(null);

    useEffect(() => {

        OrganizationCustomerService.getAllUnable().then(function (response) {
            let data = response.data;
            setCustomerList(data);
            setDefaultCustomerId(data[0]?.id);
            setDefaultCustomerName(data[0]?.name)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
        HeaderService.getAllUnable().then(function (response) {
            const data = response.data;
            setModelHeaderList(data);
            setDefaultModelHeaderId(data[0]?.id)
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

        AttributesService.getAll().then(function (response) {
            const data = response.data;
            setAttributeList(data);
            let id = AttributeUtil.getDefaultAttribute(data)?.id || data[0]?.id
            setDefaultAttributeId(id);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, []);

    const handleSubmit = () => {

        values.dateOfPlannedProduction = dateOfPlannedProduction;
        values.dateOfReceipt = dateOfReceipt;
        values.plannedDateOfShipment = plannedDateOfShipment === null ? null : DateTimeUtil.dateConvert(plannedDateOfShipment);
        values.plan = null;

        if (values.number === '') {
            values.number = null;
        }
        const {orderType, ...rest} = values
        onSubmit(rest, customerId === null ? defaultCustomerId : customerId,
            customerName === null ? defaultCustomerName : customerName,
            modelHeaderId === null ? defaultModelHeaderId : modelHeaderId,
            attributeId === null ? defaultAttributeId : attributeId, orderType
        )
        exit();
    };

    const setNull = () => {
        setCustomerId(null)
        setCustomerName(null)
        setModelHeaderId(null)
        setAttributeId(null)
        values.number = null;
        values.numberCustomer = null;
        values.dateOfPlannedProduction = null;
        values.dateOfReceipt = null;
        values.plannedDateOfShipment = null;
        setPlannedDateOfShipment(null);
        values.orderType = "STANDARD";
    }

    const exit = () => {
        setNull()
        onClose()
    }


    return (
        <Dialog open={open}>
            <DialogTitle textAlign="center">Создать заказ</DialogTitle>
            <DialogContent>
                <form onSubmit={(e) => e.preventDefault()}>
                    <Stack spacing={2}>
                    </Stack>
                    <Stack
                        sx={{
                            width: '100%',
                            minWidth: {xs: '300px', sm: '360px', md: '400px'},
                        }}
                    >
                        <CreateOrderTextFieldCustomer
                            label="Заказчик"
                            defaultValue={defaultCustomerId}
                            setId={setCustomerId}
                            setCustomerName={setCustomerName}
                            field={'customer'}
                            entityList={customerList}
                        />
                        <CreateOrderTextFieldObject
                            label="Наименование"
                            defaultValue={defaultModelHeaderId}
                            setId={setModelHeaderId}
                            field={'header'}
                            entityList={modelHeaderList}
                        />
                        <MaterialTextFieldObjectWithEntityList
                            label="Тип заказа"
                            values={values}
                            setValues={setValues}
                            field={'orderType'}
                            entityList={organizationOrderType}
                        />
                        <TextFieldWithSetValue
                            label="Номер заказа"
                            values={values}
                            setValues={setValues}
                            field={'number'}
                        />
                        <TextFieldWithSetValue
                            label="Номер заказчика"
                            values={values}
                            setValues={setValues}
                            field={'numberCustomer'}
                        />
                        <MaterialTextFieldObjectWithEntityList
                            label="Статус"
                            values={values}
                            setValues={setValues}
                            field={'status'}
                            entityList={orderStatusForCreate}
                        />
                        <CreateOrderTextFieldObject
                            label="Атрибут"
                            defaultValue={defaultAttributeId}
                            value={defaultAttributeId}
                            setId={setAttributeId}
                            field={'attribute'}
                            entityList={attributeList}
                        />
                        <OrderDatePicker
                            label="Дата поступления"
                            date={dateOfReceipt}
                            setDate={setDateOfReceipt}
                        />
                        <OrderDatePicker
                            label="Плановая дата произодства"
                            date={dateOfPlannedProduction}
                            setDate={setDateOfPlannedProduction}
                        />
                        <OrderDatePicker
                            label="Плановая дата отгрузки"
                            date={plannedDateOfShipment}
                            setDate={setPlannedDateOfShipment}
                        />
                    </Stack>
                </form>
            </DialogContent>
            <DialogActions sx={{p: '1.25rem'}}>
                <ButtonExit text={"Выйти"} onClick={exit}/>
                <ButtonAdd  loading={loading} text={"Создать"} onClick={handleSubmit}/>
            </DialogActions>
        </Dialog>
    );
};

export default CreateNewOrderModal;